import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun } from 'mobx';
import moment from 'moment';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, {FormBody, FormActions, DateInput, SelectInput, TextInput, CheckBoxInput} from '../../Form';

@inject('aggregationStore')
@observer
class AggregationEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    aggregationStore: PropTypes.object.isRequired
  };

  slug = `/station/${this.props.params.id}/aggregation`;
  title = 'Edit Aggregation';
  disposer = null;
  @observable item = {
    aggregation_method_id: null,
    source_series_id: null,
    out_series_id: null,
    interval: null,
    use_suspicious: true,
    starting_time: '00:00',
  };

  componentWillMount() {
    const { params: { aggregation_id }, aggregationStore } = this.props;

    // aggregationStore.fetchItem(id);
    this.disposer = autorun(() => {
      const foundItem = aggregationStore.findById(aggregation_id);
      if (foundItem) {
        this.item = foundItem;
        // this.item = {
        //   id: +foundItem.id,
        //   aggregation_method_id: +foundItem.aggregation_method_id,
        //   series_id: +foundItem.series_id,
        //   interval: foundItem.interval,
        //   use_suspicious: foundItem.use_suspicious,
        //   starting_time: foundItem.starting_time,
        // }
      }
    });
  }

  componentWillUnmount() {
    this.disposer();
  }

  @action onChangeAggregationMethod = e => this.item.aggregation_method_id = +e.target.value;
  @action onChangeDataSeries = e => this.item.series_id = +e.target.value;
  @action onChangeInterval = e => this.item.interval = e.target.value;
  @action onChangeUseSuspicious = e => this.item.use_suspicious = !this.item.use_suspicious;
  @action onChangeStartingTime = e => this.item.starting_time = e.target.value;

  handleSave = (e) => {
    const { notify } = this.context;

    e.preventDefault();

    delete this.item.store;

    const { aggregationStore } = this.props;

    aggregationStore.updateAggregationItem(this.item)
      .then(() => {
        notify.success();
        this.context.router.push(this.slug);
      })
      .catch((err) => {
        notify.error(err);
      });
  }

  render() {
    const { aggregationStore, params: { id }, dataSeriesItems } = this.props;

    if (aggregationStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <SelectInput
              label={'Aggregation Method'}
              fields={{ label: 'name', value: 'id' }}
              options={aggregationStore.aggregationMethods}
              onChange={this.onChangeAggregationMethod}
              value={this.item.aggregation_method_id}
            />
            <SelectInput
              label={'Source Data Series'}
              fields={{ label: 'name', value: 'id' }}
              options={dataSeriesItems}
              value={this.item.source_series_id}
              onChange={this.onChangeDataSeries}
            />
            <SelectInput
              label={'Out Data Series'}
              fields={{ label: 'name', value: 'id' }}
              options={dataSeriesItems}
              value={this.item.out_series_id}
              onChange={this.onChangeDataSeries}
            />
            <SelectInput
              label={'Aggregation Interval'}
              fields={{ label: 'label', value: 'value' }}
              options={this.props.interval}
              onChange={this.onChangeInterval}
              value={this.item.interval}
            />
            <CheckBoxInput label='Use Suspicious' checked={this.item.use_suspicious} onChange={this.onChangeUseSuspicious}/>
            <TextInput
              label={'Starting Time'}
              value={this.item.starting_time}
              onChange={this.onChangeStartingTime}
              readOnly={this.item.interval !== 'DAILY'}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default AggregationEdit;



// WEBPACK FOOTER //
// ./src/components/Station/Aggregation/AggregationEdit.js